// Class: _List.ListNode

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../hxClasses_stub").default;

// Constructor

var ListNode = function(item,next) {
	this.item = item;
	this.next = next;
}

// Meta

ListNode.__name__ = ["_List","ListNode"];
ListNode.prototype = {
	
};
ListNode.prototype.__class__ = ListNode.prototype.constructor = $hxClasses["_List.ListNode"] = ListNode;

// Init



// Statics




// Export

exports.default = ListNode;


//////////////////
// WEBPACK FOOTER
// ./lib/_gen/_List/ListNode.js
// module id = 310
// module chunks = 0